(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fp-big-pro-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fp-big-pro-price')) {
    customElements.define('fp-big-pro-price', class extends HTMLElement {
      static get observedAttributes() { return ['data-price', 'data-eligible', 'data-available', 'data-currency', 'data-quantity']; }
      connectedCallback() {
        this.scope = this.closest('[id^="MainProduct-"]');
        this.syncQuantity = () => {
          if (!this.dataset.nativeForm) return;
          const input = document.getElementById(this.dataset.nativeForm)?.elements.namedItem('quantity');
          const quantity = input ? Number(input.value) : 1;
          if (this.dataset.quantity !== String(quantity)) this.dataset.quantity = String(quantity);
          else this.render();
        };
        this.scope?.addEventListener('change', this.syncQuantity);
        this.scope?.addEventListener('input', this.syncQuantity);
        if (this.dataset.nativeForm && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.syncQuantity);
        }
        this.syncQuantity();
        this.render();
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.syncQuantity);
        this.scope?.removeEventListener('input', this.syncQuantity);
        this.unsubscribeQuantity?.();
      }
      attributeChangedCallback() { if (this.isConnected) this.render(); }
      render() {
        const price = Number(this.dataset.price);
        const quantity = this.dataset.quantity === undefined ? 1 : Number(this.dataset.quantity);
        const valid = this.dataset.eligible === 'true' && this.dataset.available !== 'false' && Number.isFinite(price) && price > 0 && Number.isInteger(quantity) && quantity > 0;
        if (this.hidden !== !valid) this.hidden = !valid;
        if (!valid) return;
        const output = this.querySelector('[data-big-pro-value]');
        const value = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(Math.round(price * quantity * 0.6) / 100);
        if (output && output.textContent !== value) output.textContent = value;
        const label = this.querySelector('[data-big-pro-label]');
        const labelText = quantity > 1 ? this.dataset.labelTotal : this.dataset.labelUnit;
        if (label && labelText && label.textContent !== labelText) label.textContent = labelText;
        const count = this.querySelector('[data-big-pro-quantity]');
        const quantityText = quantity > 1 ? ` · ×${quantity}` : '';
        if (count && count.textContent !== quantityText) count.textContent = quantityText;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
